// src/components/common/SectionTag.jsx
import React from 'react';

const SectionTag = ({ children, className = '' }) => {
  return (
    <div className="flex items-center gap-3 justify-center md:justify-start">
      <span className={`section-tag ${className}`}>
        {children}
      </span>
      <span className="hidden md:flex gap-0.5">
        <span className="w-1.5 h-1.5 rounded-full bg-[#003F88]" />
        <span className="w-1.5 h-1.5 rounded-full bg-[#F5C300]" />
        <span className="w-1.5 h-1.5 rounded-full bg-[#C8102E]" />
      </span>
    </div>
  );
};

export default SectionTag;